<template>
  <div v-loading="loading">
      <el-form :model="formData" ref="formData" :rules="rulesAdd" label-width="120px" label-position="right" size="small" style="margin-right: 3vw">
          <el-row>
              <el-col :span="24">
                  <el-form-item label="类型：" prop="cloud_type" label-width="120px" style="height: 50%">
                      <el-select v-model="formData.cloud_type" placeholder="请选择">
                          <el-option v-for="item in CloudType" :key="item.dictionary_code" :label="item.dictionary_name" :value="item.dictionary_code"></el-option>
                      </el-select>
                  </el-form-item>
              </el-col>
          </el-row>
          <el-row>
              <el-col :span="24">
                  <el-form-item label="名称：" prop="system_name" label-width="120px" style="height: 50%">
                      <el-input v-model="formData.system_name"></el-input>
                  </el-form-item>
              </el-col>
          </el-row>          
          <el-row>
              <el-col :span="24">
                  <el-form-item label="简介：" prop="system_content" label-width="120px" style="height: 50%">
                      <Xheditor ref="editor1" id="editor1" :text="formData.system_content" :fileID="fileID" :tableName="uploadForm.tableName" @change="change"></Xheditor>
                  </el-form-item>
              </el-col>
          </el-row>
          <el-row>
              <el-col :span="24">
                  <el-form-item label="排序：" prop="sort" label-width="120px" style="height: 50%">
                      <el-input-number v-model="formData.sort" controls-position="right" :min="0" :max="100000000"></el-input-number>
                  </el-form-item>
              </el-col>
          </el-row>
      </el-form>

    <div style="text-align:center;">
      <el-button type="primary" @click="addOrUpdate" size="small">保存</el-button>
    </div>
  </div>
</template>
<script>
import Xheditor from "@/components/XhComponents/XhEditor";
import AttachmentList from "@/components/AttachmentList";
import AttachmentUpload from "@/components/AttachmentUpload";
export default {
    name: "",
    props: ["data", "title","CloudType"],
    components: { Xheditor, AttachmentList, AttachmentUpload },
    data() {
        return {
            formData: this.data,
            rulesAdd: {
                system_name: [{ required: true, message: "必填项", trigger: "blur" }],
                cloud_type: [{ required: true, message: "必填项", trigger: "blur" }],
                sort: [{ required: true, message: "必填项", trigger: "blur" }],
                system_content: [{ required: true, message: "必填项", trigger: "blur" }],
            },
            loading: false,
            fileID: this.data.id,
            uploadForm: {
                tableName: "t_home_cloud",
                state: false,//上传状态
            },
        }
    },
    methods: {
        addOrUpdate() {
            let that = this;
            that.$refs.formData.validate((valid) => {
                if (valid) {
                    that.loading = true;
                    that.$api.post("/HomeCloud/saveData", that.formData,
                        function (res) {
                            that.loading = false;
                            if (res.code === "200" && res.msg === "true") {
                                that.$emit("closeModal");
                                that.$message.success("保存成功");
                            } else {
                                that.$message.warning("保存失败");
                            }
                        },
                        function (res) {
                            that.loading = false;
                            that.$message.error("服务异常，信息出错");
                        }
                    );
                } else {
                    return false;
                }
            });
        },
        change(val) {
            this.formData.system_content = val;
        },
    },
    mounted() { },
    created() { },
    watch: {
        data: function () {
            this.formData = this.data;
        },
    }
}
</script>
<style scoped lang="less">

</style>
